import React from 'react';
import PropTypes from 'prop-types';
import useSchoolCalendar from './useSchoolCalendar';
import SchoolCalendarView from './SchoolCalendarView';

export default function SchoolCalendarReadPage({ schoolYearStart, contextKey }) {
  const { loading, data, error, refresh } = useSchoolCalendar({ schoolYearStart, contextKey });
  if (error) {
    return (
      <div className="school-calendar-panel">
        <p role="alert">{error.code === 'SCHEDULE_UPDATING'
          ? 'Trwa aktualizacja kalendarza. Spróbuj ponownie za chwilę.'
          : 'Nie udało się pobrać kalendarza szkoły. Spróbuj ponownie.'}</p>
        <button type="button" className="manage-teal-button" onClick={refresh}>Spróbuj ponownie</button>
      </div>
    );
  }
  if (!data) return <p role="status">{loading ? 'Ładowanie kalendarza szkoły…' : 'Wybierz szkołę, aby zobaczyć jej kalendarz.'}</p>;
  return <SchoolCalendarView calendar={data} />;
}
SchoolCalendarReadPage.propTypes = { schoolYearStart: PropTypes.number.isRequired, contextKey: PropTypes.string.isRequired };
